<div class="popup" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="position: relative;overflow: hidden;height: 100%;">
    <div>
        
            <label i18n="@@spmsUserReg" class="textColour">{{headerNameHtml}}</label>
            <span class="example-spacer"></span>
         
    </div>
    <div style="height:80%;overflow:auto;margin-top:1%">

        <form novalidate [formGroup]="formValid" style="margin-bottom: 3em;">

            <div class="container">

                <div style="max-width: 0; max-height: 0; overflow: hidden;">

                    <input autofocus="true" />
                    
                </div>

                <div class="row topRowMargins" *ngFor="let ngModelObjectFourTemporary of ngModelObjectDivision">

                    <div class="col-lg-1" *ngIf="bootstrapColumn==1">

                    </div>

                    <div class="col-lg-2" *ngIf="bootstrapColumn==2">

                    </div>

                    <div class={{ngModelTemporary.bootstrapColumnGrid}} *ngFor = "let ngModelTemporary of ngModelObjectFourTemporary">

                        <div *ngIf="ngModelTemporary.columnType=='valueDropDown' || ngModelTemporary.columnType=='valueParentDropDown'">

                            <mat-form-field appearance="outline">
                                
                                <mat-label i18n="@@Targetstdcode">{{ngModelTemporary.displayFormColumnName}}</mat-label>
                                
                                <mat-select formControlName={{ngModelTemporary.formControlValidationName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.isRequired" (ngModelChange)="childDropDown(ngModelTemporary)">
                                    
                                    <mat-option>None</mat-option>

                                    <span *ngFor="let temporaryObject of listObjectDropDown[ngModelTemporary.dropDownIndex]"> 

                                        <mat-option *ngFor="let tempObject of temporaryObject.keyJson" [value]="tempObject" [disabled]="temporaryObject.status == 'No'" matTooltip={{temporaryObject.dropDownValueDisplay}} matTooltipPosition="right" [matTooltipClass]="{'tooltipCss':true}">

                                            {{temporaryObject.dropDownValueDisplay}}
                                        
                                        </mat-option>

                                    </span>

                                </mat-select>
                                
                                <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">
                                    
                                    <span *ngIf="formValid.get(ngModelTemporary.formControlValidationName).hasError(validation.type) && (formValid.get(ngModelTemporary.formControlValidationName).dirty || formValid.get(ngModelTemporary.formControlValidationName).touched)">
                                        
                                        {{ validation.message }}
                                    
                                    </span>

                                </mat-error>

                            </mat-form-field>
                            
                        </div>

                        <div *ngIf="ngModelTemporary.columnType=='valueSelectListStatic'">

                            <mat-form-field appearance="outline">
                                
                                <mat-label i18n="@@Targetstdcode">{{ngModelTemporary.displayFormColumnName}}</mat-label>
                                
                                <mat-select formControlName={{ngModelTemporary.formControlValidationName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.isRequired" (ngModelChange)="childDropDown(ngModelTemporary)">
                                    
                                    <mat-option>None</mat-option>

                                    <span *ngFor="let temporaryObject of listObjectDropDown[ngModelTemporary.dropDownIndex]"> 

                                        <mat-option *ngFor="let tempObject of temporaryObject.keyJson" [value]="tempObject" [disabled]="temporaryObject.status == 'No'" matTooltip={{temporaryObject.dropDownValueDisplay}} matTooltipPosition="right" [matTooltipClass]="{'tooltipCss':true}">

                                            {{temporaryObject.dropDownValueDisplay}}
                                        
                                        </mat-option>

                                    </span>

                                </mat-select>
                                
                                <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">
                                    
                                    <span *ngIf="formValid.get(ngModelTemporary.formControlValidationName).hasError(validation.type) && (formValid.get(ngModelTemporary.formControlValidationName).dirty || formValid.get(ngModelTemporary.formControlValidationName).touched)">
                                        
                                        {{ validation.message }}
                                    
                                    </span>

                                </mat-error>

                            </mat-form-field>
                            
                        </div>

                        <div *ngIf="ngModelTemporary.columnType=='valueText' || ngModelTemporary.columnType=='valueFileName' || ngModelTemporary.columnType=='valueEmail'">

                            <mat-form-field appearance="outline">

                                <mat-label i18n="Targetjointno">{{ngModelTemporary.displayFormColumnName}}</mat-label>

                                <input matInput type="text" formControlName={{ngModelTemporary.formControlValidationName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.isRequired" [readonly]="ngModelTemporary.readOnlyValue">

                                <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                    <span *ngIf="formValid.get(ngModelTemporary.formControlValidationName).hasError(validation.type) && (formValid.get(ngModelTemporary.formControlValidationName).dirty || formValid.get(ngModelTemporary.formControlValidationName).touched)">
                                
                                        {{ validation.message }}
                                
                                    </span>
                                
                                </mat-error>

                            </mat-form-field>

                        </div>

                        <div *ngIf="ngModelTemporary.columnType=='valueColor'">

                            <mat-form-field appearance="outline">

                                <mat-label i18n="Targetjointno">{{ngModelTemporary.displayFormColumnName}}</mat-label>

                                <input matInput type="color" formControlName={{ngModelTemporary.formControlValidationName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.isRequired" [readonly]="ngModelTemporary.readOnlyValue" matTooltip={{ngModelTemporary.keyValue}} matTooltipPosition="right" [matTooltipClass]="{'tooltipCss':true}">

                                <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                    <span *ngIf="formValid.get(ngModelTemporary.formControlValidationName).hasError(validation.type) && (formValid.get(ngModelTemporary.formControlValidationName).dirty || formValid.get(ngModelTemporary.formControlValidationName).touched)">
                                
                                        {{ validation.message }}
                                
                                    </span>
                                
                                </mat-error>

                            </mat-form-field>

                        </div>

                        <div *ngIf="ngModelTemporary.columnType=='valueDate' || ngModelTemporary.columnType=='valueStartDate' || ngModelTemporary.columnType=='valueEndDate'">

                            <mat-form-field appearance="outline">

                                <mat-label i18n="TargetAccountNumber">{{ngModelTemporary.displayFormColumnName}}</mat-label>

                                <input matInput formControlName={{ngModelTemporary.formControlValidationName}} [(ngModel)]="ngModelTemporary.keyValue" [matDatepicker]="i"
                                [min]="ngModelTemporary.startDateValue" [max]="ngModelTemporary.endDateValue" readonly [required]="ngModelTemporary.isRequired" (dateChange)="changeStartEndDateValue(ngModelTemporary)">

                                <mat-datepicker-toggle matSuffix [for]="i">

                                    <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>

                                </mat-datepicker-toggle>

                                <mat-datepicker #i></mat-datepicker>

                                <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">
                                    
                                    <span *ngIf="formValid.get(ngModelTemporary.formControlValidationName).hasError('matDatepickerParse') && (formValid.get(ngModelTemporary.formControlValidationName).dirty || formValid.get(ngModelTemporary.formControlValidationName).touched)">
                                    
                                        {{ validation.message }}
                                    
                                    </span>
                                    
                                </mat-error>
                                
                                <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">
            
                                    <span *ngIf="formValid.get(ngModelTemporary.formControlValidationName).hasError('required') && (formValid.get(ngModelTemporary.formControlValidationName).dirty || formValid.get(ngModelTemporary.formControlValidationName).touched)">
                                    
                                        {{ validation.message }}
                                    
                                    </span>
            
                                </mat-error>

                            </mat-form-field>

                        </div>

                        <div *ngIf="ngModelTemporary.columnType=='valueDateTime' || ngModelTemporary.columnType=='valueStartDateTime' || ngModelTemporary.columnType=='valueEndDateTime'">

                            <mat-form-field appearance="outline">

                                <mat-label i18n="TargetDateTime">{{ngModelTemporary.displayFormColumnName}}</mat-label>

                                <input matInput [(ngModel)]="ngModelTemporary.keyValue" [owlDateTimeTrigger]="i"  [owlDateTime]="i" formControlName={{ngModelTemporary.formControlValidationName}} [min]="ngModelTemporary.startDateTimeValue" [max]="ngModelTemporary.endDateTimeValue" readonly [required]="ngModelTemporary.isRequired" (dateTimeChange)="changeStartEndDateTimeValue(ngModelTemporary)">
                                
                                <em [owlDateTimeTrigger]="i" class="fas fa-caret-down" style="display: flex; position: absolute; top: 1%; left: 93%;"></em>
                            
                                <owl-date-time #i></owl-date-time>

                                <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">
            
                                    <span *ngIf="formValid.get(ngModelTemporary.formControlValidationName).hasError('required') && (formValid.get(ngModelTemporary.formControlValidationName).dirty || formValid.get(ngModelTemporary.formControlValidationName).touched)">
                                    
                                        {{ validation.message }}
                                    
                                    </span>
                
                                </mat-error>

                            </mat-form-field>

                        </div>

                        <div *ngIf="ngModelTemporary.columnType=='valueFilePath'">
                                            
                            <div class = "row" style="margin-left:0px;margin-right:0px">

                                <div class="col-lg-3" style="padding-left:inherit">

                                    <div class="file-field">
                                    
                                        <a class="btn-floating  btn-sm m-0">
                                    
                                        <em class="fas fa-paperclip mt-0" style="text-rendering: auto;color:black"></em>
                                    
                                        <input type="file" (change)="imageFunction($event,ngModelTemporary)" formControlName={{ngModelTemporary.formControlValidationName}}>
                                    
                                        </a>             
                                    
                                    </div>
                            
                                </div>

                                <div class="col-lg-7" style="padding-left:0px;padding-right:0px">
                                    
                                    <div *ngIf="ngModelTemporary.imageShow" style="width:100%;height:75px;display: inline-block;">                            
                                        
                                        <div *ngIf="ngModelTemporary.imageShow1">

                                            <div class="card" style="width:75%; display: inline-block;margin:0% 1%;height: 100%;">
                                            
                                                <div class="cardButtonDiv">   
                                                
                                                    <button type="button" class="close badge badge-danger" aria-label="Close" (click)="deleteImage(ngModelTemporary)">
                                                
                                                    <em class="fa fa-times" aria-hidden="true" style="font-family: 'Font Awesome 5 Free, Times New Roman';font-weight: 900"></em>
                                                    
                                                    </button>
                                                
                                                </div>
                                                
                                                <!-- Card content -->
                                                <div class="card-body" style="padding: 2%;overflow: hidden;height: -webkit-fill-available;" (click)="openImage(ngModelTemporary.keyValue)">
                                                
                                                    <!-- Card image -->
                                                    <div>

                                                        <img id="expand" class="card-img-top" [src]="getSanitizer(ngModelTemporary.keyValue)" alt="Card Image cap" style="width: 100%;height: 75px;">

                                                    </div>

                                                </div>                            
                                            
                                            </div>
                                    
                                        </div>

                                        <div *ngIf="ngModelTemporary.fileShow">

                                            <div class="card" style="width:100%; display: inline-block;margin:0% 1%;background-color:lightcyan">
                                            
                                                <div class="cardButtonDiv">   
                                                
                                                    <button type="button" class="close badge badge-danger" aria-label="Close" (click)="deleteImage(ngModelTemporary)">
                                                
                                                    <em class="fa fa-times" aria-hidden="true" style="font-family: 'Font Awesome 5 Free, Times New Roman';font-weight: 900"></em>
                                                    
                                                    </button>
                                                
                                                </div>
                                                
                                                <!-- Card content -->
                                                <div class="card-body" style="padding: 2%;overflow: hidden;height: -webkit-fill-available;">
                                                
                                                    <span>{{ngModelTemporary.imageNameDisplay}}</span>

                                                </div>                              
                                            
                                            </div>
                                    
                                        </div>

                                    </div>
                                
                                </div>

                                <div class="col-lg-2">

                                    <div *ngIf="ngModelTemporary.downloadIconShow">

                                        <a (click)="docdownload(ngModelTemporary)" style="font-size:1.5rem;color:green"><em class="fas fa-download" title="Download"></em></a>

                                    </div>

                                </div>

                            </div>

                        </div>

                        <div *ngIf="ngModelTemporary.columnType=='valuePassword'">

                            <mat-form-field appearance="outline">

                                <mat-label i18n="Targetjointno">{{ngModelTemporary.displayFormColumnName}}</mat-label>

                                <input matInput [type]="hide ? 'text' : 'password'" formControlName={{ngModelTemporary.formControlValidationName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.isRequired">

                                <mat-icon matSuffix *ngIf="eyeIcon" (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}
                                </mat-icon>

                                <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                    <span *ngIf="formValid.get(ngModelTemporary.formControlValidationName).hasError(validation.type) && (formValid.get(ngModelTemporary.formControlValidationName).dirty || formValid.get(ngModelTemporary.formControlValidationName).touched)">
                                    
                                        {{ validation.message }}
                                    
                                    </span>
                                
                                </mat-error>

                            </mat-form-field>

                        </div>

                        <div *ngIf="ngModelTemporary.columnType=='valueInteger'">

                            <mat-form-field appearance="outline">

                                <mat-label i18n="Targetjointno">{{ngModelTemporary.displayFormColumnName}}</mat-label>

                                <input matInput type="text" formControlName={{ngModelTemporary.formControlValidationName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.isRequired">

                                <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                    <span *ngIf="formValid.get(ngModelTemporary.formControlValidationName).hasError(validation.type) && (formValid.get(ngModelTemporary.formControlValidationName).dirty || formValid.get(ngModelTemporary.formControlValidationName).touched)">
                                
                                        {{ validation.message }}
                                
                                    </span>
                                
                                </mat-error>

                            </mat-form-field>

                        </div>

                        <div *ngIf="ngModelTemporary.columnType=='valueDecimal'">

                            <mat-form-field appearance="outline">

                                <mat-label i18n="TargetNumberNumeric">{{ngModelTemporary.displayFormColumnName}}</mat-label>

                                <input matInput type="text" formControlName={{ngModelTemporary.formControlValidationName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.isRequired">

                                <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                    <span *ngIf="formValid.get(ngModelTemporary.formControlValidationName).hasError(validation.type) && (formValid.get(ngModelTemporary.formControlValidationName).dirty || formValid.get(ngModelTemporary.formControlValidationName).touched)">
                                    
                                        {{ validation.message }}
                                    
                                    </span>
                                
                                </mat-error>

                            </mat-form-field>

                        </div>

                        <div *ngIf="ngModelTemporary.columnType=='valueCheckbox'">

                            <mat-checkbox formControlName={{ngModelTemporary.formControlValidationName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.isRequired">{{ngModelTemporary.displayFormColumnName}}</mat-checkbox>
                
                            <mat-error style="font-size:75%;font-weight:normal" *ngFor="let validation of ngModelTemporary.validationMessages">

                                <span *ngIf="formValid.get(ngModelTemporary.formControlValidationName).hasError(validation.type) && (formValid.get(ngModelTemporary.formControlValidationName).dirty || formValid.get(ngModelTemporary.formControlValidationName).touched)">
                            
                                    {{ validation.message }}
                            
                                </span>
                            
                            </mat-error>

                        </div>
                        <div *ngIf="ngModelTemporary.columnType=='valueRadio'" appearance="outline">
                        <div  style="display: flex;margin-top: -6px;">
                            <label style="padding: 0px 5px;font-size: 14px;">{{ngModelTemporary.displayFormColumnName}} : </label>
                            <mat-radio-group style="display: grid;margin-top: -1px;
                            overflow-x: auto;"  formControlName={{ngModelTemporary.formControlValidationName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.isRequired">
                            <mat-radio-button style="padding: 0px 5px;" *ngFor = "let eachradiovalue of ngModelTemporary.valueRadio" [value]="eachradiovalue" (change)="radiochange($event)">{{eachradiovalue}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <mat-error style="    font-size: 75%;
                    font-weight: normal;" *ngFor="let validation of ngModelTemporary.validationMessages">

                        <span *ngIf="formValid.get(ngModelTemporary.formControlValidationName).hasError(validation.type) && (formValid.get(ngModelTemporary.formControlValidationName).dirty || formValid.get(ngModelTemporary.formControlValidationName).touched)">
                    
                            {{ validation.message }}
                    
                        </span>
                    
                    </mat-error>

                        </div>

                        <div *ngIf="ngModelTemporary.columnType=='valueTextArea'">

                            <mat-form-field appearance="outline">

                                <mat-label i18n="Targetjointno">{{ngModelTemporary.displayFormColumnName}}</mat-label>

                                <textarea matInput type="text" formControlName={{ngModelTemporary.formControlValidationName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.isRequired">{{ngModelTemporary.keyValue}}</textarea>

                                <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                    <span *ngIf="formValid.get(ngModelTemporary.formControlValidationName).hasError(validation.type) && (formValid.get(ngModelTemporary.formControlValidationName).dirty || formValid.get(ngModelTemporary.formControlValidationName).touched)">
                                
                                        {{ validation.message }}
                                
                                    </span>
                                
                                </mat-error>

                            </mat-form-field>

                        </div>

                    </div>

                    <div class="col-lg-1" *ngIf="bootstrapColumn==1">

                    </div>

                    <div class="col-lg-2" *ngIf="bootstrapColumn==2">

                    </div>

                </div>

            </div>

        </form>

    </div>

    <div class="row mb-1 topRowMargins" style= "position:sticky;left:0;bottom:0;width:100%">

        <div class="col-lg text-center">

            <div style="text-align: end;">
           
                <form novalidate [formGroup]="formValidCheckbox">

                    <span *ngIf='buttonNameClose=="Save"'>

                        <mat-checkbox formControlName="isCheckboxSelected" [(ngModel)]="isCheckboxSelected" style="margin-right:1%"></mat-checkbox>

                    </span>

                    <button i18n="@@TargetClear" type="button" (click)="sendDataAndClose()"
                    class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    style="padding-left:1.2rem;padding-right: 1.2rem;margin-bottom:14px" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean">{{buttonNameClose}}</button>

                    <button i18n="@@TargetCancel" type="button" (click)="cancel()"
                    class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    style="padding-left:1.2rem;padding-right: 1.2rem;margin-bottom:14px" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean" >Cancel</button>

                </form>

            </div>
        
        </div>
        
    </div>

</div>